<template>
    <div class="detail-module">

        <div class="box">
            <div class="select-box flex flex-y-center flex-start">
                <div class="select-item mr-30 flex-between flex-y-center" @click="selectTypePopup">
                    <div class="select-tit">{{ checkedType && checkedType.name }}</div>
                    <van-icon name="play" class="select-arrow" />
                </div>
                <div class="select-item mr-30 flex-between flex-y-center" @click="selectEmployeePopup">
                    <div class="select-tit">{{ checkedEmployee && checkedEmployee.name }}</div>
                    <van-icon name="play" class="select-arrow" />
                </div>
                <div class="select-item flex-between flex-y-center" @click="selectTimePopup">
                    <div class="select-tit">{{ dateTxt }}</div>
                    <van-icon name="play" class="select-arrow" />
                </div>
            </div>
            <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
                <div class="detail-box">
                    <div class="table-tab  flex flex-x-center flex-between">
                        <div :class="`tab-item ${todoStatus == 1 ? 'active' : ''}`" @click="clickTab(1)">
                            待完成({{ baseData.unfinished }})
                        </div>
                        <div :class="`tab-item item-text ${todoStatus == 2 ? 'active' : ''}`" @click="clickTab(2)">
                            已完成({{ baseData.finished }})
                        </div>
                    </div>
                    <van-list v-model="loading" :finished="finished" :loading="loading" finished-text="没有更多了" @load="getDetail" :offset="20" :immediate-check="false">
                        <div class="detail-item" v-for="(items, index) in detailList" :key="index">
                            <div class="flex flex-between">
                                <div class="radio-box" v-if="items.canSelect">
                                    <van-checkbox v-model="items.isCheck" :disabled="getTodoCheckDisabled(items.remindDate, items.isCheck, items.status)" @click="todoCheck(items.id)">

                                    </van-checkbox>
                                </div>
                                <div class="detail-title flex-1">
                                    {{ items.message }}
                                </div>
                            </div>
                            <div v-if="items.source == 1" class="remind">客人为匿名评价，请勿联系客人!</div>

                            <div v-for="(item, index) in items.contactList" :key="index">
                                <div class="info-remain  flex flex-end flex-y-center">
                                    <img :src="item.avatar" class="head-icon" v-if="item.avatar && items.source != 1" alt="" />
                                    <div class="flex-1 flex-y-center ml-20 fl" v-if="item.name && items.source != 1">
                                        {{ item.name }}
                                    </div>
                                    <div class="flex-1 flex-y-center ml-20 fl" v-if="!item.name && items.source != 1">
                                    </div>
                                    <div class="flex-1 flex-y-center ml-20 fl" v-if="items.source == 1">工单来源：满意度评价
                                    </div>
                                    <div class="follow fr" @click="toCustomer(item)" v-if="items.type == 12">
                                        立即处理
                                        <van-icon name="arrow" color="#CCCCCC" />
                                    </div>
                                    <div class="follow fr" @click="toCustomer(item)" v-else>
                                        跟进
                                        <van-icon name="arrow" color="#CCCCCC" />
                                    </div>
                                </div>
                                <!-- 1：院余提醒，2：券余提醒，3：生日提醒，4：消费提醒，5：任务，6：会员流转，7：会员被其他顾问激活，8：会员异店消费，9：专属预约，10：审核提醒，11：当天到店提醒 -->
                                <div v-if="items.type == 1 || items.type == 2">
                                    <!-- 院余提醒，券余提醒 -->
                                    <div class="list-box flex flex-between flex-y-center">
                                        <div class="flex-1 name">名称</div>
                                        <div class="num">次数/余额</div>
                                        <div class="time">过期时间</div>
                                    </div>
                                    <div v-for="(oItem, index) in item.detailList" :key="index" class="list-box list-box-b flex flex-between flex-y-center">
                                        <div class="flex-1 name">{{ oItem.name }}</div>
                                        <div class="num">{{ oItem.balance }}</div>
                                        <div class="time">{{ oItem.endDate }}</div>
                                    </div>
                                </div>
                                <div v-if="items.type == 3">
                                    <!-- 生日提醒 -->
                                    <div class="list-box flex flex-between flex-y-center">
                                        <div class="flex-1 name">名称</div>
                                        <div class="arrive-time">生日</div>
                                    </div>
                                    <div v-for="(oItem, index) in item.detailList" :key="index" class="list-box list-box-b flex flex-between flex-y-center">
                                        <div class="flex-1 name">{{ oItem.name }}</div>
                                        <div class="arrive-time">{{ oItem.birthday }}</div>
                                    </div>
                                </div>
                                <div v-if="items.type == 4">
                                    <!-- 消费提醒 -->
                                    <div class="list-box flex flex-between flex-y-center">
                                        <div class="flex-1 name">名称</div>
                                        <div class="arrive-time">最后到店消费时间</div>
                                    </div>
                                    <div v-for="(oItem, index) in item.detailList" :key="index" class="list-box list-box-b flex flex-between flex-y-center">
                                        <div class="flex-1 name">{{ oItem.name }}</div>
                                        <div class="arrive-time">{{ oItem.transDate }}</div>
                                    </div>
                                </div>
                                <div v-if="items.type == 6">
                                    <!-- 会员流转 -->
                                    <div class="list-box flex flex-between flex-y-center">
                                        <div class="flex-1 name">姓名</div>
                                        <div class="arrive-time">最后到店消费时间</div>
                                    </div>
                                    <div v-for="(oItem, index) in item.detailList" :key="index" class="list-box list-box-b flex flex-between flex-y-center">
                                        <div class="flex-1 name">{{ oItem.name }}</div>
                                        <div class="arrive-time">{{ oItem.transDate }}</div>
                                    </div>
                                </div>
                                <div v-if="items.type == 7">
                                    <!-- 会员被其他顾问激活 -->
                                    <div class="list-box flex flex-between flex-y-center">
                                        <div class="flex-1 name">姓名</div>
                                        <div class="num">跳卡等级</div>
                                        <div class="time">变更顾问</div>
                                    </div>
                                    <div v-for="(oItem, index) in item.detailList" :key="index" class="list-box list-box-b flex flex-between flex-y-center">
                                        <div class="flex-1 name">{{ oItem.custName }}</div>
                                        <div class="num">{{ oItem.cardClass }}</div>
                                        <div class="time">{{ oItem.counselor }}</div>
                                    </div>
                                </div>
                                <div v-if="items.type == 8">
                                    <!-- 会员异店消费 -->
                                    <div class="list-box flex flex-between flex-y-center">
                                        <div class="flex-1 name">项目</div>
                                        <div class="num">门店</div>
                                        <div class="time">消费时间</div>
                                    </div>
                                    <div v-for="(oItem, index) in item.detailList" :key="index" class="list-box list-box-b flex flex-between flex-y-center">
                                        <div class="flex-1 name">{{ oItem.name }}</div>
                                        <div class="num">{{ oItem.storeName }}</div>
                                        <div class="time">{{ oItem.dateTime }}</div>
                                    </div>
                                </div>
                                <div v-if="items.type == 11 || items.type == 9">
                                    <!-- 会员预约到店提醒, 专属预约 -->
                                    <div class="list-box flex flex-between flex-y-center">
                                        <div class="flex-1 name">预约门店</div>
                                        <div class="num">预约美疗师</div>
                                        <div class="time">预约时间</div>
                                    </div>
                                    <div v-for="(oItem, index) in item.detailList" :key="index" class="list-box list-box-b flex flex-between flex-y-center">
                                        <div class="flex-1 name">{{ oItem.storeName }}</div>
                                        <div class="num">{{ oItem.staffName }}</div>
                                        <div class="time">{{ oItem.dateTime }}</div>
                                    </div>
                                </div>
                                <div v-if="items.type == 10">
                                    <!-- 审核提醒 -->
                                    <div class="list-box flex flex-between flex-y-center">
                                        <div class="flex-1 name">审核类型</div>
                                        <div class="num">申请人</div>
                                        <div class="time">名称/数额</div>
                                    </div>
                                    <div v-for="(oItem, index) in item.detailList" :key="index" class="list-box list-box-b flex flex-between flex-y-center">
                                        <div class="flex-1 name">{{ oItem.auditType }}</div>
                                        <div class="num">{{ oItem.proposer }}</div>
                                        <div class="time">{{ oItem.content }}</div>
                                    </div>
                                </div>
                                <div v-if="items.type == 12">
                                    <!--工单 -->
                                    <div v-for="(oItem, index) in item.detailList" :key="index" class="list-box list-box-b flex-col flex-between flex-start">
                                        <div class="flex flex-start mb-40">
                                            <div class="title" v-if="oItem.workType == 1">投诉内容：</div>
                                            <div class="title" v-else-if="oItem.workType == 2">反馈内容：</div>
                                            <div class="flex-1">{{ oItem.details }}</div>
                                        </div>
                                        <div class="flex flex-start">
                                            <div class="title">客户诉求：</div>
                                            <div class="flex-1">{{ oItem.appeal }}</div>
                                        </div>

                                    </div>
                                </div>
                                <div v-if="items.type == 13">
                                    <!-- 新客回访 -->
                                    <div class="list-box flex flex-between flex-y-center">
                                        <div class="flex-1 name">上次护理项目</div>
                                        <div class="num">美疗师</div>
                                        <div class="time">护理时间</div>
                                    </div>
                                    <div v-for="(oItem, index) in item.detailList" :key="index" class="list-box list-box-b flex flex-between flex-y-center">
                                        <div class="flex-1 name">{{ oItem.name }}</div>
                                        <div class="num">{{ oItem.therapists }}</div>
                                        <div class="time">{{ oItem.dateTime }}</div>
                                    </div>
                                </div>
                                <div v-if="items.type == 14">
                                    <!-- 术后回访 -->
                                    <div class="list-box flex flex-between flex-y-center">
                                        <div class="flex-1 name">术后回访</div>
                                        <div class="time">手术时间</div>
                                    </div>
                                    <div v-for="(oItem, index) in item.detailList" :key="index" class="list-box list-box-b flex flex-between flex-y-center">
                                        <div class="flex-1 name">{{ oItem.shopName }}</div>
                                        <div class="time">{{ oItem.transDate }}</div>
                                    </div>
                                </div>
                                <div v-if="items.type == 15">
                                    <!-- VIP未到诊提醒 -->
                                    <div class="list-box flex flex-between flex-y-center">
                                        <div class="flex-1 name">上次消费门诊</div>
                                        <div class="time">到诊时间</div>
                                    </div>
                                    <div v-for="(oItem, index) in item.detailList" :key="index" class="list-box list-box-b flex flex-between flex-y-center">
                                        <div class="flex-1 name">{{ oItem.shopName }}</div>
                                        <div class="time">{{ oItem.transDate }}</div>
                                    </div>
                                </div>
                                <div v-if="items.type == 16">
                                    <!-- 会员未到诊提醒 -->
                                    <div class="list-box flex flex-between flex-y-center">
                                        <div class="flex-1 name">上次消费门诊</div>
                                        <div class="time">到诊时间</div>
                                    </div>
                                    <div v-for="(oItem, index) in item.detailList" :key="index" class="list-box list-box-b flex flex-between flex-y-center">
                                        <div class="flex-1 name">{{ oItem.shopName }}</div>
                                        <div class="time">{{ oItem.transDate }}</div>
                                    </div>
                                </div>
                                <div v-if="items.type == 17">
                                    <!-- 异诊提醒 -->
                                    <div class="list-box flex flex-between flex-y-center">
                                        <div class="flex-1 name">消费门诊</div>
                                        <div class="time">到诊时间</div>
                                    </div>
                                    <div v-for="(oItem, index) in item.detailList" :key="index" class="list-box list-box-b flex flex-between flex-y-center">
                                        <div class="flex-1 name">{{ oItem.storeName }}</div>
                                        <div class="time">{{ oItem.dateTime }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="bottom-box flex flex-between flex-y-center">
                                <van-icon name="clock-o" class="clock" />
                                <div class="flex-1">提醒时间</div>
                                <div class="time">{{ items.remindDate }}</div>
                            </div>
                        </div>
                    </van-list>

                </div>
            </van-pull-refresh>
        </div>
        <van-popup v-model="showTypePopup" round position="bottom" closeable>
            <picker title="全部待办" v-model="checkedType" :list="typeList" @change="onTypeChange"></picker>
        </van-popup>
        <van-popup v-model="showEmployeePopup" round position="bottom" closeable>
            <picker :title="employeePopupTitle" v-model="checkedEmployee" :list="employeeList" @change="onEmployeeChange">
            </picker>
        </van-popup>
        <van-popup v-model="showTimePopup" round position="bottom" closeable>
            <date-picker v-model="dateType" @submit="handleDate" :pickerType="pickerType"></date-picker>
        </van-popup>
    </div>
</template>
<script>
    import request from "@/utils/request";
    import { getTodoCheckDisabled } from './utils'
    import DatePicker, { getDateText, getFormatTime, PICKER_TYPE } from '@/components/DatePicker';
    import Picker from '@/components/Picker';
    import { Toast } from 'vant'
    import { openEnterpriseChat } from '@/utils/wxCodeAuth'
    import { keepAliveAfterHandler } from "@/router/router";
    import { mapState } from 'vuex'
    import { getCookie } from '@/utils'

    export default {
        name: "toDoNewDetail",
        components: {
            DatePicker,
            Picker
        },
        data() {
            return {
                pickerType: PICKER_TYPE.MONTH,
                loading: false,
                finished: false,
                refreshing: false,
                baseData: {},//数据
                detailList: [],
                page: 1,
                total: 0,
                showTimePopup: false, // 选择时间弹窗
                showEmployeePopup: false, // 选择员工弹窗
                showTypePopup: false,//选择待办事件弹窗
                dateType: '2',//日期对应id1-本日；2-本月；3-上月 默认本月
                beginMonth: '', // 开始日期
                endMonth: '', // 结束日期
                employeeList: [],// 员工列表
                checkedEmployee: null,//所选员工
                todoEventList: [],// 待办列表
                typeList: [],// 待办类型列表
                checkedType: null,// 所选待办类型
                todoStatus: "1", //tab
                postId: '',//权限
                employeePopupTitle: '',
            };
        },
        beforeRouteLeave(to, from, next) {
            keepAliveAfterHandler.call(this, to, from)
            next()
        },
        computed: {
            dateTxt() {
                return getDateText(this.dateType, this.beginMonth, this.endMonth, this.pickerType)
            },
            ...mapState({
                regionPostId: (state) => {
                    return state.user.permissions.regionPostId
                },// 区经区总id
            }),
        },
        mounted() {
            this.postId = getCookie('postId') || localStorage.getItem('postId');
            this.dimension = JSON.parse(localStorage.getItem('employeeInfo')).dimension
            this.employeePopupTitle = this.dimension == 1 ? '全部员工' : '主诊人' // 选择器标题

            this.checkedEmployee = JSON.parse(this.$route.query.employee)
            this.checkedType = JSON.parse(this.$route.query.checkedType)
            // 自定义加载图标
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0, // 持续展示 toast
                loadingType: 'spinner',
            });
            this.getDetail()
            this.getEmpList()
            this.getTypeList()
        },
        methods: {
            getTodoCheckDisabled,//判断是否勾选
            // 获取详情
            getDetail() {
                const beginDate = getFormatTime(this.beginMonth, this.pickerType)
                const endDate = getFormatTime(this.endMonth, this.pickerType)
                let params = {
                    beginMonth: beginDate,
                    endMonth: endDate,
                    dateType: this.dateType,
                    type: this.checkedType.id,
                    employeeId: this.checkedEmployee.id,
                    limit: 10,
                    page: this.page,
                    todoStatus: this.todoStatus
                }
                if (this.regionPostId.includes(this.postId)) {
                    params.id = this.$route.query.id,
                        params.storeId = this.$route.query.storeId
                }
                request({
                    url: `/todo/employeeTodo`,
                    method: "get",
                    params: params
                })
                    .then((res) => {
                        Toast.clear();

                        this.baseData = res.data
                        this.detailList = this.page == 1 ? res.data.pageData.list : this.detailList.concat(res.data.pageData.list);
                        this.page += 1;
                        this.total = res.data.pageData.total;
                        this.detailList.forEach(item => {
                            item.isCheck = item.status == 2 ? true : false
                        });
                    }).catch((error) => {
                        this.finished = true
                        Toast({ position: 'top', message: error ?? '' })
                    }).finally(() => {
                        this.loading = false;
                        if (this.detailList.length >= this.total) {
                            this.finished = true;
                        }
                    });
            },
            // 获取员工列表
            getEmpList() {
                let params = null
                if (this.regionPostId.includes(this.postId)) {
                    params = {
                        id: this.$route.query.id,
                        storeId: this.$route.query.storeId
                    }
                }
                request({
                    url: "/sys/params/selectByStoreTreasure",
                    method: "get",
                    params: params
                })
                    .then((res) => {
                        this.employeeList = res.data
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            // 获取待办类型列表
            getTypeList() {
                request({
                    url: "/todo/typeList",
                    method: "get",
                })
                    .then((res) => {
                        this.typeList = res.data
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            // 跟进 去顾客 或者打开添加页  item.wxExternalUserid,item.isWxContact,item.name,
            toCustomer(val) {
                const { workType, storeNo, guid } = val
                if ([1, 2].includes(workType)) {
                    this.$router.push({ name: 'repairOrderDetail', query: { workNoTypeId: workType, storeNo, guid } });
                    return
                }
                // if (val.wxExternalUserid && val.isWxContact == 1)   //是好友有userid，打开会话
                //     openEnterpriseChat('', val.wxExternalUserid, '', '')
                // else
                //跳转至绑定客户界面
                this.$router.push({ name: "customerDetail", query: { custId: val.custId, phone: val.mobile, } });
            },
            // 勾选状态
            todoCheck(todoId) {
                request({
                    url: `/todo/${todoId}`,
                    method: "put",
                }).then((res) => {
                    if (res.code == 0) {
                        this.detailList = this.detailList.map(item => {
                            if (item.id == todoId) {
                                item.isCheck == true
                            }
                            return item
                        })
                    }

                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
            },
            // 弹窗
            selectTimePopup() {
                this.showTimePopup = true
            },
            selectEmployeePopup() {
                this.showEmployeePopup = true
            },
            selectTypePopup() {
                this.showTypePopup = true
            },
            //
            // tab切换
            clickTab(tabIndex) {
                this.todoStatus = tabIndex
                this.onRefresh();
            },
            onRefresh() {
                this.page = 1
                // // 清空列表数据
                this.finished = false;
                this.detail = {}
                // // 重新加载数据
                // // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.refreshing = false;
                this.getDetail();
            },
            // 筛选相关
            handleDate(id, begin, end) {
                this.showTimePopup = false
                this.dateType = id
                if (!id) {
                    this.beginMonth = begin
                    this.endMonth = end
                } else {
                    this.beginMonth = ''
                    this.endMonth = ''
                }
                this.onRefresh()
            },
            onEmployeeChange(data) {
                this.checkedEmployee = data
                this.showEmployeePopup = false
                this.onRefresh()
            },
            onTypeChange(data) {
                this.checkedType = data
                this.showTypePopup = false
                this.onRefresh()

            },
        },
    };
</script>
<style lang="less" scoped>
    .van-pull-refresh {
        min-height: 100%;
    }

    ::-webkit-scrollbar {
        display: none;
    }

    .mr-30 {
        margin-right: 30px;
    }

    .detail-module {
        background-color: #fff;
        height: 100%;
        overflow-y: auto;
    }

    .box {
        background-color: #f9fafc;
    }

    .select-box {
        background-color: #fff;
        margin-bottom: 20px;
        padding: 30px 34px;

        .select-tit {
            font-size: 28px;
            color: #35434c;
        }

        .select-arrow {
            transform: rotate(90deg);
            font-size: 24px;
            margin-left: 10px;
        }
    }

    .table-tab {
        width: 100%;
        height: 100%;
        display: flex;
        padding-bottom: 20px;
        border-bottom: 1px solid #d7d7d7;
        margin-bottom: 30px;
    }

    .tab-item {
        width: 250px;
        height: 42px;
        font-size: 30px;
        font-weight: 400;
        color: #a0acb5;
        text-align: center;
        position: relative;
    }

    .item-text {
        margin-left: 102px;
    }

    .tab-item.active {
        color: #35434c;
        font-weight: bold;
    }

    .tab-item.active::after {
        position: absolute;
        bottom: -20px;
        content: "";
        width: 110px;
        height: 6px;
        border-radius: 3px;
        background: #37dbe0;
        left: 50%;
        transform: translateX(-50%);
    }

    .detail-box {
        background: #ffffff;
        border-radius: 20px 20px 0 0;
        margin: 0 auto;
        padding: 30px 30px;
    }

    .detail-item {
        width: 690px;
        background: #ffffff;
        box-shadow: 0px 6px 26px 0px rgba(2, 2, 2, 0.08);
        border-radius: 20px;
        padding: 30px 20px 0 20px;
        margin: 0 auto;
        margin-bottom: 20px;
    }

    .detail-title {
        font-size: 28px;
        color: #35434c;
        margin-left: 20px;
        margin-bottom: 16px;
        font-weight: 700;
    }

    :deep(.van-checkbox) {
        margin-bottom: 0 !important;
    }

    .remind {
        font-size: 24px;
        font-weight: 700;
        color: #f65252;
        margin: 0 0 30px 52px;
    }

    .info-remain {
        height: 70px;
        background: #e9f2ff;
        border-radius: 4px;
        color: #a0acb5;
        font-size: 28px;
        padding: 12px 20px;
        margin-bottom: 29px;

        .head-icon {
            width: 46px;
            height: 46px;
            border-radius: 50%;
            margin-right: 20px;
        }

        .head-icon-m {
            margin-left: -18px;
        }
    }

    .list-box {
        font-size: 26px;
        color: #a0acb5;
        margin-bottom: 25px;

        .name {
            margin-left: 10px;
        }

        .num {
            width: 130px;
            margin-right: 75px;
            text-align: center;
        }

        .time {
            width: 150px;
            margin-right: 25px;
            text-align: center;
        }

        .arrive-time {
            margin-right: 25px;
            text-align: center;
        }

        .title {
            width: 135px;
            font-size: 26px;
            font-weight: 700;
            color: #35434c;
        }
    }

    .list-box-b {
        color: #35434c;
    }

    .bottom-box {
        height: 100px;
        border-top: 1px solid #d7d7d7;
        background-color: #fff;
        border-radius: 0 0 20px 20px;
        font-size: 28px;
        color: #35434c;

        .clock {
            font-size: 32px;
            margin-right: 20px;
        }

        .time {
            width: 344px;
            text-align: right;
        }
    }

    :deep(.van-checkbox__icon .van-icon) {
        width: 32px;
        height: 32px;
        line-height: 32px;
    }

    :deep(.van-checkbox__icon--checked .van-icon) {
        background-color: #fff;
        border-color: #a0acb5;
        color: #a0acb5;
    }
</style>